import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOnboardingStatus } from '../state/courierSlice';
import { getIsAuthenticated, getUser } from '../state/authSlice';
import { OnboardingRoute, AuthRoutePath } from '../config/routePaths';
import { needsOnboarding } from '../utils/postLoginRoute';

/**
 * Component that handles auto-redirect to onboarding wizard
 * when onboarding status is NOT_STARTED and user is an admin.
 */
export const OnboardingRedirect: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const onboardingStatus = useSelector(getOnboardingStatus);
  const isAuthenticated = useSelector(getIsAuthenticated);
  const user = useSelector(getUser);

  useEffect(() => {
    // Don't redirect if not authenticated
    if (!isAuthenticated) return;

    // Don't redirect if already on onboarding or auth pages (including the
    // welcome email's /auth/reset-password/:token set-password link)
    if (
      location.pathname === OnboardingRoute ||
      location.pathname === AuthRoutePath ||
      location.pathname.startsWith('/auth/reset-password') ||
      location.pathname.startsWith('/reset-password')
    ) {
      return;
    }

    if (needsOnboarding(user?.roles, onboardingStatus)) {
      navigate(OnboardingRoute, { replace: true });
    }
  }, [onboardingStatus, isAuthenticated, user, location.pathname, navigate]);

  return <>{children}</>;
};

export default OnboardingRedirect;
